import { Plugin } from 'ckeditor5';
import FootNoteEditing from './footnoteediting';
import FootNoteUI from './footnoteui';

export default class FootNote extends Plugin {
    static get requires() {
        return [FootNoteEditing, FootNoteUI];
    }
}